exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.match-count[data-v-02e1f37e] {\n  padding: 4px 16px;\n  font-weight: 500;\n}\n", ""]);

// exports
